const constants = {
  cookieName: "token",
  storageKeyOrderOrganizers: "storageKeyOrderOrganizers"
};

export default constants;
